module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/salesTools/save-as-template-img.svg"